'use client'

import { createContext, useContext } from 'react'

import {
  PUBLIC_SESSION_RUNTIME,
  type SessionRuntime,
} from '@/services/auth/sessionRuntime'

export { PUBLIC_SESSION_RUNTIME }
export type { SessionRuntime } from '@/services/auth/sessionRuntime'

const SessionRuntimeContext = createContext<SessionRuntime>(
  PUBLIC_SESSION_RUNTIME,
)

export function SessionRuntimeProvider({
  children,
  value,
}: {
  children: React.ReactNode
  value: SessionRuntime
}) {
  return (
    <SessionRuntimeContext.Provider value={value}>
      {children}
    </SessionRuntimeContext.Provider>
  )
}

export function useSessionRuntime(): SessionRuntime {
  return useContext(SessionRuntimeContext)
}
